import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";
import { useTheme } from "./ThemeProvider";

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? t("common.themeLight") : t("common.themeDark")}
      aria-pressed={isDark}
      title={isDark ? t("common.themeLight") : t("common.themeDark")}
      data-testid="theme-toggle"
      className={cn(
        "grid h-9 w-9 place-items-center rounded-lg border text-ink-2 transition-all hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
        isDark
          ? "border-primary/30 bg-primary/10 text-primary-2 hover:bg-primary/15"
          : "border-line/20 bg-card hover:bg-canvas",
        className,
      )}
    >
      {isDark ? <IconSun /> : <IconMoon />}
    </button>
  );
}

function IconMoon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

function IconSun() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}
